import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCurrentUser, setUserId } from "../../../context/sessionSlice";
import { Navigate } from "react-router-dom";


export default function Logout() {

    let dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentUser(''));
        dispatch(setUserId(''));
        sessionStorage.removeItem('userData');
    }, []);

    return <Navigate to='/login' />;
}